module.exports = __webpack_public_path__ + "static/img/icon_apply_buy_xfq.292dfb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/my/icon_apply_buy_xfq.png
// module id = uZgX
// module chunks = 80